import { render, staticRenderFns } from "./ClassmateImage.vue?vue&type=template&id=d93d1988&scoped=true"
import script from "./ClassmateImage.vue?vue&type=script&lang=js"
export * from "./ClassmateImage.vue?vue&type=script&lang=js"
import style0 from "./ClassmateImage.vue?vue&type=style&index=0&id=d93d1988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93d1988",
  null
  
)

export default component.exports